import { FormModelConfig, HeadBtnConfig } from 'liyu-pc-base/api/typing';

import { useUserStore } from 'liyu-pc-base/init-plugin';

import { message } from 'ant-design-vue';
import Handlebars from 'handlebars';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { useRequest } from 'liyu-pc-base/init-plugin';
import { getObjList, getObjListBySelectedRowKeys } from 'liyu-pc-base/utils/function';
import { reactive } from 'vue';
export const head_btn_form = ({
  dataSource,
  button,
  selectedRowKeys,
  event_obj,
}: {
  dataSource: any[];
  button: HeadBtnConfig;
  selectedRowKeys: any[];
  event_obj: any;
}) => {
  const request = useRequest();
  const preProcessData = button.preProcessData;
  const model_config = button.model_config as FormModelConfig;
  const title = model_config.title;
  const ok_url = model_config.ok_url;
  const cancel_url = model_config.cancel_url;
  const method = model_config.method || 'post';
  const init_data = model_config.init_data;
  const api_fields = model_config.api_fields;
  const batch_api_fields = model_config.batch_api_fields;
  const form_config = model_config.form;
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org
  const org_id = current_org?.id;

  let record = null;
  if (preProcessData) {
    record = preProcessData({ dataSource, selectedRowKeys });
  } else {
    record = dataSource.find(item => selectedRowKeys.includes(item.id));
  }

  let model_data = {
    ...form_config.model,
    ...record,
  };
  if (api_fields) {
    model_data = {
      ...model_data,
      ...getObjList(api_fields, record),
    };
  }
  if (init_data) {
    model_data = {
      ...model_data,
      ...init_data,
    };
  }
  // 创建表单模态框配置
  const form_modal_config = reactive({
    settings: form_config.settings || {
      labelAlign: 'right',
      layout: 'vertical',
      col: [],
    },
    dynamicFieldList: form_config.dynamicFieldList || [],
    model: reactive(model_data),
    rules: form_config.rules || {},
    options: form_config.options || {},
  });

  // 创建模态框
  const tempModal = reactive({
    open: true,
    loading: false,
    title: Handlebars.compile(title || '')({ record: model_data }),
    form: form_modal_config,
    ok: (data: any) => {
      return new Promise(function (resolve, reject) {
        if (!ok_url) {
          resolve(null);
          return;
        }
        tempModal.loading = true;
        let submit_data = data;
        // if (api_fields) {
        //   submit_data = {
        //     ...submit_data,
        //     ...getObjList(api_fields, data),
        //   }
        // }
        if (batch_api_fields) {
          submit_data = {
            ...submit_data,
            ...getObjListBySelectedRowKeys(batch_api_fields, dataSource, selectedRowKeys),
          };
        }
        if (button.beforeCommitProcessData) {
          submit_data = button.beforeCommitProcessData({
            dataSource,
            selectedRowKeys,
            data: submit_data,
          });
        }
        submit_data.org_id = org_id;

        request({
          url: ok_url,
          method: method,
          data: submit_data,
        })
          .then(() => {
            message.success('操作成功');
            event_obj.emit('refresh');
            resolve(null);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            tempModal.loading = false;
          });
      });
    },
    cancel: (data: any) => {
      return new Promise(function (resolve, reject) {
        if (!cancel_url) {
          resolve(null);
          return;
        }
        tempModal.loading = true;

        let submit_data = data;
        // if (api_fields) {
        //   submit_data = {
        //     ...submit_data,
        //     ...getObjList(api_fields, data),
        //   }
        // }
        if (batch_api_fields) {
          submit_data = {
            ...submit_data,
            ...getObjListBySelectedRowKeys(batch_api_fields, dataSource, selectedRowKeys),
          };
        }
        if (button.beforeCommitProcessData) {
          submit_data = button.beforeCommitProcessData({
            dataSource,
            selectedRowKeys,
            data: submit_data,
          });
        }
        submit_data.org_id = org_id;

        request({
          url: cancel_url,
          method: method,
          data: submit_data,
        })
          .then(() => {
            event_obj.emit('refresh');
            resolve(null);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            tempModal.loading = false;
          });
      });
    },
  });

  // 显示模态框
  modalBox(tempModal);
};
